module.exports = __webpack_public_path__ + "img/career-b3.2e8af674.jpg";